import React, { useState, useRef } from "react";
import axios from "axios";

const CustomLinkForLIONResource = (props) => {
  const { URL, Title, QuestionId, IbeReleaseId, AssignedResourceKey, Product  } = props.data;
  const { baseUrl } = props;

  const [newwin, setNewwin] = useState(null); 
  const timeOpenedRef = useRef(0); 
  const previousLinkTimeRef = useRef(0); 
  const [isCompleted, setIsCompleted] = useState(false); 

  const handleLinkClick = (e) => {
    e.preventDefault();

    if (newwin && !newwin.closed) {
      const finalTime = previousLinkTimeRef.current < 30 ? 60 : previousLinkTimeRef.current;
      sendDataToAPI(finalTime);
      newwin.close();
    }

    const openedWindow = window.open(URL, "urlPopup", "width=1200,height=600,scrollbars=yes,titlebar=no");

    if (!openedWindow) {
      console.error("Failed to open window. Popup blocker may be enabled.");
      alert("Popup blocker detected. Please allow popups for this website.");
      return;
    }

    setNewwin(openedWindow);

    const startTime = Date.now();
    previousLinkTimeRef.current = 0; 
    setIsCompleted(false);

    
    const intervalId = setInterval(() => {
      const timeElapsed = Math.round((Date.now() - startTime) / 1000);
      previousLinkTimeRef.current = timeElapsed; 

      if (openedWindow.closed) {
        clearInterval(intervalId);
        if (!isCompleted) {
          setIsCompleted(true); 

          const finalTimeOpened = timeElapsed < 30 ? 60 : timeElapsed;
          timeOpenedRef.current = finalTimeOpened; 

          console.log(`Final Time Opened: ${timeOpenedRef.current} seconds`);

          sendDataToAPI(timeOpenedRef.current);
        }
      } else if (timeElapsed % 30 === 0) {
        console.log(`Time Opened (interval): ${timeElapsed} seconds`);
        sendDataToAPI(timeElapsed);
      }
    }, 1000); 
  };

  const sendDataToAPI = (timeOpened) => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");

    if (Product !== "KENTRO") {
      console.log(Product);
      console.log("API not called");
      return; 
    }

    const headers = {
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      "Content-Type": "application/json", // Optional: Define the content type if needed
    };
    const encodedURL = encodeURIComponent(URL);
    if (token != null) {
      axios
        .post(
          baseUrl +
          `Student/KentroResourceCompleteUpdate?studentkey=${studentkey}&districtId=${districtID}&ReleaseID=${IbeReleaseId}&AssignedResourceKey=${AssignedResourceKey}&QuestionId=${QuestionId}&url=${encodedURL}&TimeSpent=${timeOpened}`,
          { headers }
        )
        .then((response) => {
          console.log("Data sent to API:", response.data);
        })
        .catch((error) => {
          console.error("Error sending data to API:", error);
        });
    }
  };

  return (
    <a
      href={URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleLinkClick}
    >
      {Title}
    </a>
  );
};

export default CustomLinkForLIONResource;